module.exports = __webpack_public_path__ + "9563a2d8d0e3e4bf8dc425578cabe868.svg";